import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import UserReviewsManagement from '../../../components/siteadmin/UserReviewsManagement/UserReviewsManagement';

import userReviewsQuery from './userReviewsQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './UserReviews.css';

const UserReviews = (props) => {

    const { data: { loading }, title } = props;

    const { data: { getReviewsDetails, refetch } } = props;

    return (
        <UserReviewsManagement
            data={getReviewsDetails}
            title={title}
            refetch={refetch}
            loading={loading}
        />
    );
}

UserReviews.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        getReviewsDetails: PropTypes.array,
    })
};

UserReviews.defaultProps = {
    data: {
        loading: true
    }
};

export default compose(
    withStyles(s),
    withQuery(userReviewsQuery,
        {
            options: (props) => ({
                variables: {
                    currentPage: 1,
                    searchList: ''
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }),
)(UserReviews);